import React, { useEffect, useState } from "react";
import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

let cachedUserList: any = null;

export const getUserName = async (isEditedByUserId: any) => {
  try {
    if (!cachedUserList) {
      const res = await axios.get(
        `${API_BASE_URL}/api/Users/ApplicationUsers/Details`
      );
      cachedUserList = res.data.data;
    }

    const findUser = cachedUserList.find(
      (user: any) => user.userID === parseInt(isEditedByUserId)
    );
    console.log("getUserName findUser", findUser);
    return findUser ? `<strong>${findUser.userName}</strong>` : "another user";
  } catch (error) {
    console.error("Error fetching user name:", error);
    return "user";
  }
};
